import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import {
	PACKAGE_NAME,
	TEAM_NAME,
} from '@jira/navigation-apps__atlassian-navigation-ui/src/constants.tsx';
import type { Nav4NotificationsData$key } from './__generated__/Nav4NotificationsData.graphql';
import { Nav4Notifications } from './Nav4Notifications.tsx';

type Nav4NotificationsDataProps = {
	queryReference: Nav4NotificationsData$key;
};

export const Nav4NotificationsData = (props: Nav4NotificationsDataProps): React.JSX.Element => {
	const { queryReference } = props;
	// eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
	const fragmentData = useFragment<Nav4NotificationsData$key>(
		graphql`
			fragment Nav4NotificationsData on Query
			@argumentDefinitions(collabContextRoutingAri: { type: "String" }) {
				...Nav4Notifications @arguments(collabContextRoutingAri: $collabContextRoutingAri)
			}
		`,
		// eslint-disable-next-line @atlassian/relay/use-fragment-naming
		queryReference,
	);

	return (
		<JSErrorBoundary
			id="nav4-notifications-error-boundary"
			packageName={PACKAGE_NAME}
			teamName={TEAM_NAME}
			fallback="flag"
		>
			<Nav4Notifications fragmentData={fragmentData} />
		</JSErrorBoundary>
	);
};
